import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIduInline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 47,
	height: 22,
	viewBox: "0 0 47 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3098 21.4539H8.47089V0H16.2995C18.4603 0 20.3208 0.429497 21.881 1.28849C23.4481 2.1405 24.6562 3.36963 25.5053 4.97588C26.3544 6.57514 26.779 8.48867 26.779 10.7165C26.779 12.9513 26.3544 14.8718 25.5053 16.478C24.6631 18.0843 23.4584 19.3169 21.8913 20.1759C20.3242 21.0279 18.4637 21.4539 16.3098 21.4539ZM13.5968 17.0332H16.1131C17.3005 17.0332 18.3049 16.8307 19.1265 16.4256C19.9549 16.0136 20.5797 15.3467 21.0008 14.4248C21.4288 13.496 21.6428 12.2599 21.6428 10.7165C21.6428 9.17308 21.4288 7.94395 21.0008 7.02908C20.5728 6.10723 19.9411 5.44378 19.1058 5.03873C18.2773 4.62669 17.2556 4.42067 16.0406 4.42067H13.5968V17.0332Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 21.4536V6.7746H5.46511V21.4536H0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.937 0H47V13.8445C47 15.4445 46.6276 16.8384 45.8829 18.0262C45.1381 19.2069 44.0995 20.1222 42.7671 20.772C41.4348 21.4148 39.8872 21.7362 38.1243 21.7362C36.341 21.7362 34.7831 21.4148 33.4508 20.772C32.1184 20.1222 31.0832 19.2069 30.3453 18.0262C29.6074 16.8384 29.2384 15.4445 29.2384 13.8445V0H34.3117V13.3938C34.3117 14.1345 34.4688 14.7947 34.7831 15.3746C35.1043 15.9545 35.5518 16.4087 36.1258 16.7371C36.6997 17.0655 37.3659 17.2296 38.1243 17.2296C38.8827 17.2296 39.5455 17.0655 40.1126 16.7371C40.6866 16.4087 41.1341 15.9545 41.4553 15.3746C41.7764 14.7947 41.937 14.1345 41.937 13.3938V0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4.23452V0.000198364H5.46511V4.23452H0Z",
			fill: "#C42464"
		})
	]
});
export default SvgIduInline;
